import en_US from 'antd/locale/en_US';
import ka_GE from 'antd/locale/ka_GE';
import hy_AM from 'antd/locale/hy_AM';
import ru_RU from 'antd/locale/ru_RU';
import kk_KZ from 'antd/locale/kk_KZ';

/** Kyrgyz — no dedicated Ant Design pack in this version; English chrome is acceptable fallback. */
const kyFallback = en_US;

const ANT_DESIGN_LOCALES = {
  en: en_US,
  ka: ka_GE,
  hy: hy_AM,
  ru: ru_RU,
  ky: kyFallback,
  kk: kk_KZ,
};

export function getAntdLocale(lang) {
  if (lang != null && ANT_DESIGN_LOCALES[lang]) {
    return ANT_DESIGN_LOCALES[lang];
  }
  return en_US;
}
